export default {
    title: "Váš schvalující manažer je {email}"
}